import { AGGREGATED_FIELD_STATE } from '../../../../store/products/helpers/aggregatedFieldState';

export const resolveAggregatedBooleanCheckboxValue = (field) => {
  if (!field) return false;

  if (field.state === AGGREGATED_FIELD_STATE.COMMON) {
    return Boolean(field.value);
  }

  if (field.state === AGGREGATED_FIELD_STATE.EMPTY) {
    return false;
  }

  if (field.state === AGGREGATED_FIELD_STATE.MULTIPLE) {
    const applicableCount = field.stats?.applicableCount || 0;
    const withValueCount = field.stats?.withValueCount || 0;

    if (!applicableCount) return false;
    if (withValueCount === 0) return false;
    if (withValueCount === applicableCount) return true;
    return 'indeterminate';
  }

  return false;
};

export const isAggregatedBooleanMixed = (field) => (
  resolveAggregatedBooleanCheckboxValue(field) === 'indeterminate'
);
